// Facebook Pixel tracking utility
export const FB_PIXEL_ID = '1391179942026724'

export const pageview = () => {
  window.fbq('track', 'PageView')
}

// Track specific events
export const event = (name, options = {}) => {
  window.fbq('track', name, options)
}

// Common events
export const trackRegistration = () => {
  event('StartRegistration')
}

export const trackContact = () => {
  event('Contact')
}

export const trackViewContent = (contentName) => {
  event('ViewContent', {
    content_name: contentName,
    content_type: 'product'
  })
}

export const trackInitiateCheckout = () => {
  event('InitiateCheckout')
}

export const trackCompleteRegistration = () => {
  event('CompleteRegistration')
} 